import { Box, Collapse, Flex, Img, Skeleton, Text } from "@chakra-ui/react";
import { useState, useEffect } from "react";

const Description = ({ ingredients }) => {
  const [openItem, setOpenItem] = useState(null);
  useEffect(() => {
    if (ingredients.length > 0) {
      setOpenItem(ingredients[0].name);
    }
  }, []);
  return (
    <>
      {ingredients &&
        ingredients.map((ingredient) => (
          <Box key={ingredient.image} width="100%">
            <Box
              mt={5}
              p="20px"
              width="100%"
              onClick={() => setOpenItem(ingredient.name)}
              backgroundColor="light"
            >
              <Text width="100%" variant="cartBold" color="black">
                {ingredient.name}
              </Text>
            </Box>
            <Collapse in={true} animateOpacity>
              <Flex
                mt="4"
                p="10px"
                shadow="md"
                rounded="md"
                borderWidth={1}
                justifyContent="space-between"
                flexDirection={{ base: "column", lg: "row" }}
              >
                {/* <Box
                  _hover={{
                    cursor: "pointer",
                  }}
                  bg="light"
                  minH={"200px"}
                  height="200px"
                  w={{ base: "100%", lg: "25%" }}
                >
                  <Img
                    bg="light"
                    lazy="true"
                    width="100%"
                    height="100%"
                    overflow="hidden"
                    src={ingredient.sourceUrl}
                    alt="product-image"
                    objectFit="contain"
                    fallback={<Skeleton w="100%" />}
                  />
                </Box> */}
                <Text
                  variant="productCardDescription"
                  // width={{ base: "100%", lg: "70%" }}
                >
                  {ingredient.description}
                </Text>
              </Flex>
            </Collapse>
          </Box>
        ))}
    </>
  );
};
export default Description;
